import { FunctionComponent } from "react";
import { useSelector } from "react-redux";

import { OffersContainerStyled, CardGrid } from "./styles";

import OfferCard from "components/OfferCard";

import {
  purchasableOffers,
  purchasableExternallyOffers,
  pendingActivationOffers,
  activeOffers,
  cancelledOffers,
  provisioningOffers,
  cardPendingOffers,
  cardExpiredOffers,
  notPurchasableOffers,
} from "state/offers-slice";
import { setDebugSubject } from "utils/debugHelper";

const OffersContainer: FunctionComponent = () => {
  const offersPendingActivation = useSelector(pendingActivationOffers) || [];
  const offersPurchasable = useSelector(purchasableOffers) || [];
  const offersPurchasableExternally = useSelector(purchasableExternallyOffers) || [];
  const offersActive = useSelector(activeOffers) || [];
  const offersCancelled = useSelector(cancelledOffers) || [];
  const offersProvisioning = useSelector(provisioningOffers) || [];
  const offersCardExpired = useSelector(cardExpiredOffers) || [];
  const offersCardPending = useSelector(cardPendingOffers) || [];
  const notPurchasable = useSelector(notPurchasableOffers) || [];

  const offersToDisplay = [
    ...offersCardExpired,
    ...offersPendingActivation,
    ...offersPurchasable,
    ...offersPurchasableExternally,
    ...offersActive,
    ...offersCancelled,
    ...offersProvisioning,
    ...offersCardPending,
    ...notPurchasable,
  ];

  const numberOfPendingActivationOffers: number = offersPendingActivation.length;

  setDebugSubject(offersToDisplay);

  return (
    <OffersContainerStyled>
      <CardGrid data-testid="home-offers">
        {offersToDisplay.map((el) => (
          <OfferCard
            key={el.name}
            data-testid={`home-offers-card-${el.name}`}
            offer={el}
            numberOfPendingActivationOffers={numberOfPendingActivationOffers}
          />
        ))}
      </CardGrid>
    </OffersContainerStyled>
  );
};

export default OffersContainer;
